import { Box, Checkbox, makeStyles, Typography } from '@material-ui/core';
import React, { FC } from 'react';

const useStyles = makeStyles(theme => ({
  box: {
    margin: theme.spacing(4),
    padding: theme.spacing(2),
    border: '3px solid lightgray',
    borderRadius: '10px'
  },
  imgsvg: {
    height: '25px',
    width: '100%',
    margin: '3px'
  },
  blockCard: {
    marginLeft: '5px'
  },
  labelPayment: {
    fontWeight: 'bold',
    whiteSpace: 'nowrap'
  }
}));

interface Props {
  checked: boolean;
  onChangeCheckBox: (checked: boolean) => void;
  cards: string[];
  label: string;
  rightIcon: string;
  subLabel?: string;
}

const PaymentMethod: FC<Props> = ({
  children,
  cards,
  onChangeCheckBox,
  label,
  checked,
  rightIcon,
  subLabel
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.box}>
      <Box display="flex" flexWrap="nowrap">
        <Box display="flex" alignItems="center">
          <Checkbox
            checked={checked}
            color="primary"
            disabled={checked}
            onChange={(_, checked) => onChangeCheckBox(checked)}
          />
          <Typography className={classes.labelPayment} variant="subtitle1">
            {label}
          </Typography>
          <Box display="flex" alignItems="center" marginLeft={2}>
            {cards.map(card => (
              <img
                key={card}
                src={card}
                alt="icon card"
                className={classes.imgsvg}
              />
            ))}
          </Box>
        </Box>
        <Box
          display="flex"
          justifyContent="end"
          width="100%"
          alignItems="center"
        >
          <Box display="flex">
            <img src={rightIcon} alt="icon" className={classes.imgsvg} />
          </Box>
        </Box>
      </Box>
      {subLabel && checked && (
        <Box display="flex" marginLeft={'42px'} alignItems="center">
          <Typography variant="body2">{subLabel}</Typography>
        </Box>
      )}
      {checked ? children : null}
    </Box>
  );
};

export default PaymentMethod;
